<div class="group cursor-pointer" (click)="onCardClick($event)" [class.pointer-events-none]="!item.routerLink">
  <div
    class="bg-white dark:bg-[rgb(17,17,17)] text-gray-900 dark:text-gray-100 rounded-xl overflow-hidden shadow-[4px_4px_15px_rgba(0,0,0,0.1)] hover:shadow-[6px_6px_20px_rgba(0,0,0,0.15)] transition-transform hover:scale-105 duration-300 ease-in-out h-full flex flex-row sm:flex-col will-change-transform"
    style="transform: translateZ(0)"
    >
    <!-- Imagen -->
    @if (item.imgSrc) {
      <div class="shrink-0 w-28 h-auto sm:w-full sm:h-48 overflow-hidden flex relative">
        @if (loading) {
          <div class="absolute inset-0 bg-gray-200 dark:bg-zinc-800 animate-pulse"></div>
        }
        <img [src]="item.imgSrc" [alt]="item.imgAlt || ''" loading="lazy"
             (load)="onImgLoad()"
             class="w-full h-full object-cover object-center filter grayscale brightness-75 group-hover:grayscale-0 group-hover:brightness-100 transition duration-500 image-hover"
             [style.opacity]="loading ? 0 : 1" />
      </div>
    }

    <!-- Contenido -->
    <div class="flex flex-col justify-between p-4 sm:p-5 flex-1 card-content-animated">
      <div>
  <h4 class="text-lg font-semibold mb-1 text-gray-800 dark:text-gray-100 group-hover:text-white">
          {{ item.title }}
        </h4>
  <p class="text-gray-600 dark:text-gray-400 group-hover:text-white text-sm">
          {{ item.description }}
        </p>
      </div>
      <div class="mt-3">
        <span class="text-blue-500 dark:text-blue-300 font-medium inline-flex items-center gap-2" [ngClass]="getButtonClasses()">
          {{ item.buttonText }}
          @if (item.buttonIcon) { <i [class]="item.buttonIcon"></i> }
        </span>
      </div>
    </div>
  </div>
</div>
